// extracted by mini-css-extract-plugin
export default {"browser":"Browser_browser__SmMdO","browser_patients":"Browser_browser_patients__0K7Ot","browser__title":"Browser_browser__title__F5Q8A"};